module.exports = __webpack_public_path__ + "static/img/phone_box.2fe20bc4.png";